// externals
import type { Reducer } from 'redux';

// libraries
import type { Dealer } from '@makemydeal/dr-shared-types';
import { initActionTypes } from '@makemydeal/dr-shared-store';

export type DealerReducerState = Partial<Dealer>;

export const DEALER_INITIAL_STATE: DealerReducerState = {};

export const reducer: Reducer<DealerReducerState> = (state: DealerReducerState = DEALER_INITIAL_STATE, action: any) => {
    switch (action.type) {
        case initActionTypes.INIT_PENCIL_SUCCESS: {
            return {
                ...state,
                ...action.payload.dealerConfig
            };
        }
        default: {
            return state;
        }
    }
};
